import { render, staticRenderFns } from "./RecommenD.vue?vue&type=template&id=14a6b93e&scoped=true"
import script from "./RecommenD.vue?vue&type=script&lang=js"
export * from "./RecommenD.vue?vue&type=script&lang=js"
import style0 from "./RecommenD.vue?vue&type=style&index=0&id=14a6b93e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a6b93e",
  null
  
)

export default component.exports